import React, { useEffect, useState } from "react";

const InputOption = ({ data, placeholder, label, onChange }) => {
    const [searchTerm, setSearchTerm] = useState("");
    const [filteredData, setFilteredData] = useState([]);
    const [isOpen, setIsOpen] = useState(false);
    const [selectedOption, setSelectedOption] = useState("");

    useEffect(() => {
        setFilteredData(data);
    }, [data]);

    useEffect(() => {
        if (isOpen) {
            setSearchTerm("");
        }
    }, [isOpen]);

    const handleSearch = (e) => {
        const term = e.target.value.toLowerCase();
        setSearchTerm(term);

        const filtered = data.filter(
            (item) =>
                item.name.toLowerCase().includes(term)
        );
        setFilteredData(filtered);
    };

    const handleOptionSelect = (item) => {
        setSelectedOption(`${item.name}`);
        setSearchTerm(""); // Reset search term
        setIsOpen(false); // Close dropdown
        if (onChange) onChange(item.id); // Pass selected value to parent
    };

    const toggleDropdown = () => {
        setIsOpen((prev) => !prev);
    };

    const closeDropdown = () => {
        setIsOpen(false);
    };

    return (
        <div className="w-full max-w-sm mx-auto my-2">
            {/* Input Field */}
            <div className="relative">
                <input
                    type="text"
                    placeholder={placeholder}
                    value={isOpen ? searchTerm : selectedOption}
                    onChange={handleSearch}
                    onClick={toggleDropdown} // Single click toggles the dropdown
                    className="text-black block w-full p-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                />
                <div className="absolute inset-y-0 right-2 flex items-center pointer-events-none">
                    <svg
                        className="w-5 h-5 text-gray-400"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M19 9l-7 7-7-7"
                        ></path>
                    </svg>
                </div>
            </div>

            {/* Dropdown Menu */}
            {isOpen && (
                <div
                    className="absolute z-10 w-auto mt-1 bg-white border border-gray-300 rounded-md shadow-lg max-h-48 overflow-y-auto"
                    onBlur={closeDropdown} // Close dropdown when it loses focus
                    tabIndex={-1} // Make the div focusable
                >
                    {filteredData.length > 0 ? (
                        filteredData.map((item) => (
                            <div
                                key={item.id}
                                className="px-4 py-2 text-sm text-gray-700 cursor-pointer hover:bg-blue-100"
                                onClick={() => handleOptionSelect(item)}
                            >
                                {item.name}
                            </div>
                        ))
                    ) : (
                        <div className="px-4 py-2 text-sm text-gray-500">
                            No options found.
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

export default InputOption;
